export default __webpack_public_path__ + "static/media/offerImg.d88d1406.jpg";